export const GET_RESOURCES_FILES_REQUEST = 'GET_RESOURCES_FILES_REQUEST';
export const GET_RESOURCES_FILES_SUCCESS = 'GET_RESOURCES_FILES_SUCCESS';
export const GET_RESOURCES_FILES_ERROR = 'GET_RESOURCES_FILES_ERROR';
export const GET_RESOURCES_FILE_REQUEST = 'GET_RESOURCES_FILE_REQUEST';
export const GET_RESOURCES_FILE_SUCCESS = 'GET_RESOURCES_FILE_SUCCESS';
export const GET_RESOURCES_FILE_ERROR = 'GET_RESOURCES_FILE_ERROR';
export const ADD_RESOURCES_FILE_REQUEST = 'ADD_RESOURCES_FILE_REQUEST';
export const ADD_RESOURCES_FILE_SUCCESS = 'ADD_RESOURCES_FILE_SUCCESS';
export const ADD_RESOURCES_FILE_ERROR = 'ADD_RESOURCES_FILE_ERROR';
export const UPLOAD_RESOURCES_FILES_REQUEST = 'UPLOAD_RESOURCES_FILES_REQUEST';
export const UPLOAD_RESOURCES_FILE_REQUEST = 'UPLOAD_RESOURCES_FILE_REQUEST';
export const UPLOAD_RESOURCES_FILE_SUCCESS = 'UPLOAD_RESOURCES_FILE_SUCCESS';
export const UPLOAD_RESOURCES_FILE_ERROR = 'UPLOAD_RESOURCES_FILE_ERROR';
export const UPLOAD_RESOURCES_FILES_SUCCESS = 'UPLOAD_RESOURCES_FILES_SUCCESS';
export const UPLOAD_RESOURCES_FILES_ERROR = 'UPLOAD_RESOURCES_FILES_ERROR';
export const UPDATE_RESOURCES_FILE_REQUEST = 'UPDATE_RESOURCES_FILE_REQUEST';
export const UPDATE_RESOURCES_FILE_SUCCESS = 'UPDATE_RESOURCES_FILE_SUCCESS';
export const UPDATE_RESOURCES_FILE_ERROR = 'UPDATE_RESOURCES_FILE_ERROR';
export const ADD_RESOURCES_NEW_FILE = 'ADD_RESOURCES_NEW_FILE';
export const DELETE_RESOURCES_FILE_REQUEST = 'DELETE_RESOURCES_FILE_REQUEST';
export const DELETE_RESOURCES_FILE_SUCCESS = 'DELETE_RESOURCES_FILE_SUCCESS';
export const DELETE_RESOURCES_FILE_ERROR = 'DELETE_RESOURCES_FILE_ERROR';
export const EXPORT_RESOURCES_FILE_REQUEST = 'EXPORT_RESOURCES_FILE_REQUEST';
export const EXPORT_RESOURCES_FILE_SUCCESS = 'EXPORT_RESOURCES_FILE_SUCCESS';
export const EXPORT_RESOURCES_FILE_ERROR = 'EXPORT_RESOURCES_FILE_ERROR';
export const SET_RESOURCES_DEFAULT_PERCENTAGE_TO_FILE =
  'SET_RESOURCES_DEFAULT_PERCENTAGE_TO_FILE';
export const RESET_RESOURCES_UPLOAD_FILES = 'RESET_RESOURCES_UPLOAD_FILES';
export const UPDATE_RESOURCES_SEARCH_TERM = 'UPDATE_RESOURCES_SEARCH_TERM';
export const CLOSE_RESOURCES_FILE = 'CLOSE_RESOURCES_FILE';
export const UPDATE_RESOURCES_BLOB_REQUEST = 'UPDATE_RESOURCES_BLOB_REQUEST';
export const UPDATE_RESOURCES_BLOB_SUCCESS = 'UPDATE_RESOURCES_BLOB_SUCCESS';
export const UPDATE_RESOURCES_BLOB_ERROR = 'UPDATE_RESOURCES_BLOB_ERROR';
export const UPDATE_RESOURCES_EDITOR_SEARCH_TERM =
  'UPDATE_RESOURCES_EDITOR_SEARCH_TERM';
export const SET_RESOURCES_THEME = 'SET_RESOURCES_THEME';
export const OPEN_RESOURCES_FILE = 'OPEN_RESOURCES_FILE';

export const DELETE_RESOURCES_FILES_REQUEST = 'DELETE_RESOURCES_FILES_REQUEST';
export const DELETE_RESOURCES_FILES_SUCCESS = 'DELETE_RESOURCES_FILES_SUCCESS';
export const DELETE_RESOURCES_FILES_ERROR = 'DELETE_RESOURCES_FILES_ERROR';
export const EXPORT_RESOURCES_FILES_REQUEST = 'EXPORT_RESOURCES_FILES_REQUEST';
export const EXPORT_RESOURCES_FILES_SUCCESS = 'EXPORT_RESOURCES_FILES_SUCCESS';
export const EXPORT_RESOURCES_FILES_ERROR = 'EXPORT_RESOURCES_FILES_ERROR';
export const OPEN_RESOURCES_FILES_REQUEST = 'OPEN_RESOURCES_FILES_REQUEST';
export const OPEN_RESOURCES_FILES_SUCCESS = 'OPEN_RESOURCES_FILES_SUCCESS';
export const OPEN_RESOURCES_FILES_ERROR = 'OPEN_RESOURCES_FILES_ERROR';
